// 3D Planet: favorieten zonder account. Handles in localStorage 'tdp-favs'; hartje op kaarten en productpagina,
// teller in de header, overzicht op /pages/favorieten (details via /products/<handle>.js).
(function () {
  var KEY = 'tdp-favs';
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} sync(); }
  function has(h) { return load().indexOf(h) >= 0; }
  function toggle(h) { var l = load(); var i = l.indexOf(h); if (i >= 0) l.splice(i, 1); else l.unshift(h); save(l); return i < 0; }
  var HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10A4.2 4.2 0 0 1 12 8a4.2 4.2 0 0 1 7.5 2.5c0 5.4-7.5 10-7.5 10z"/></svg>';
  function sync() {
    var n = load().length;
    document.querySelectorAll('[data-tdp-fav-count]').forEach(function (c) { c.textContent = n; c.hidden = n === 0; });
    document.querySelectorAll('[data-tdp-fav-btn]').forEach(function (b) {
      var on = has(b.dataset.tdpFavBtn); b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? 'Verwijder uit favorieten' : 'Bewaar als favoriet');
      var t = b.querySelector('.tdp-fav-btn__text'); if (t) t.textContent = on ? 'Bewaard als favoriet' : 'Bewaar als favoriet';
    });
  }
  function decorateCards() {
    document.querySelectorAll('product-card[data-product-handle]:not([data-tdp-fav-ready])').forEach(function (card) {
      card.setAttribute('data-tdp-fav-ready', '1');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'tdp-fav-btn tdp-fav-btn--card'; b.dataset.tdpFavBtn = card.dataset.productHandle; b.innerHTML = HEART;
      card.appendChild(b);
    });
  }
  function decorateProduct() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) return;
    var host = document.querySelector('.product-form-buttons'); if (!host || host.querySelector('[data-tdp-fav-btn]')) return;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'tdp-fav-btn tdp-fav-btn--product'; b.dataset.tdpFavBtn = m[1];
    b.innerHTML = HEART + '<span class="tdp-fav-btn__text">Bewaar als favoriet</span>'; host.appendChild(b);
  }
  function renderPage() {
    var box = document.querySelector('[data-tdp-favorites]'); if (!box) return;
    var list = load();
    if (!list.length) { box.innerHTML = '<p class="tdp-favorites__empty">Nog geen favorieten. Klik op het hartje bij een product om het hier te bewaren.</p>'; return; }
    box.innerHTML = '<ul class="tdp-favorites__grid"></ul>'; var ul = box.firstChild;
    list.forEach(function (h) {
      var li = document.createElement('li'); li.className = 'tdp-favorites__item'; li.innerHTML = '<a class="tdp-favorites__link" href="/products/' + h + '"><span class="tdp-favorites__media"></span><span class="tdp-favorites__title">…</span><span class="tdp-favorites__price"></span></a><button type="button" class="tdp-fav-btn tdp-fav-btn--card is-active" data-tdp-fav-btn="' + h + '" aria-label="Verwijder uit favorieten">' + HEART + '</button>';
      ul.appendChild(li);
      fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) { li.remove(); return; }
        var img = (p.featured_image || (p.images && p.images[0]) || ''); if (img) li.querySelector('.tdp-favorites__media').innerHTML = '<img src="' + img.replace(/(\.[a-z]+)(\?|$)/, '_600x$1$2') + '" alt="" loading="lazy">';
        li.querySelector('.tdp-favorites__title').textContent = p.title;
        var cents = p.price; li.querySelector('.tdp-favorites__price').textContent = (p.price_varies ? 'vanaf ' : '') + '€' + Math.floor(cents / 100) + ',' + ('0' + (cents % 100)).slice(-2);
      });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tdp-fav-btn]'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); toggle(b.dataset.tdpFavBtn);
    if (document.querySelector('[data-tdp-favorites]')) renderPage();
  });
  function init() { decorateCards(); decorateProduct(); renderPage(); sync(); }
  var pending = null;
  new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(function () { decorateCards(); decorateProduct(); sync(); }, 150); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
